import { MyAccountPage } from './myaccount.page';

export default MyAccountPage;
